import _ from 'lodash';

const ELLIPSIS_STRING = '...';

export const despace = string => _.replace(string, /\s+/g, ' ').trim();

export const addEllipsisToString = (string, maxLength) =>  maxLength && string.length > maxLength
    ? string.slice(0, maxLength).concat(ELLIPSIS_STRING)
    : string;
